// Confirmed organisation facts, shared by page copy, meta tags, JSON-LD and the
// build-time prerender script (scripts/prerender.mjs). Plain JS with no Vite
// imports so Node can load it too.
//
// Only put facts here that WSTSC has confirmed. Class times, term dates, fees,
// parking and social handles other than YouTube are still awaiting
// confirmation - see OWNER_INPUT_NEEDED.md.

export const SITE_URL = "https://wstsc.org.au";

export const ORG = {
  name: "Western Sydney Tamil Study Centre",
  shortName: "WSTSC",
  description:
    "Western Sydney Tamil Study Centre (WSTSC) is a not-for-profit community language school teaching Tamil language and culture to children in Blacktown, outside mainstream school hours.",
  email: "info@wstsc.org.au",
  phones: {
    committee: { label: "Committee", display: "0451 112 478", tel: "+61451112478" },
    principal: { label: "Principal", display: "0469 427 599", tel: "+61469427599" },
  },
  whatsapp: "https://wa.me/61451112478",
  venue: {
    name: "Walters Road Public School",
    streetAddress: "158 Walters Road",
    locality: "Blacktown",
    region: "NSW",
    postcode: "2148",
    country: "AU",
  },
  mapsUrl: "https://maps.app.goo.gl/hMRUGRGpG2YnxCdQ8",
  // WSTSC's Google Maps listing (checked 25 Sep 2026: "Western Sydney Tamil
  // Study Centre" at Walters Road). Used for the reviews section's links when
  // live review data isn't available. The CID link opens the listing directly.
  googleListing: {
    url: "https://maps.google.com/?cid=599066772110755877",
    reviewsEndpoint: "/google-reviews.php",
  },
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Walters+Road+Public+School,+158+Walters+Road,+Blacktown+NSW+2148&output=embed",
  hostSchoolPage:
    "https://waltersrd-p.schools.nsw.gov.au/learning-and-support/learning-opportunities/western-sydney-tamil-study-centre-wstsc",
  logo: `${SITE_URL}/wstsc-logo.png`,
  // Official profiles, verified 25 Sep 2026: each is titled "Western Sydney
  // Tamil Study Centre", the Facebook "About" text matches this website, and
  // the site has linked all three since launch. Used by the header, footer,
  // homepage social section and JSON-LD sameAs.
  social: {
    youtube: "https://www.youtube.com/@wstsc-org-au",
    youtubeChannelId: "UCHNS35hbh8DDEXqjsV_n7fA",
    facebook: "https://www.facebook.com/wstsc.org.au",
    instagram: "https://www.instagram.com/wstsc.org.au/",
  },
};

ORG.sameAs = [ORG.social.youtube, ORG.social.facebook, ORG.social.instagram];

export const VENUE_ADDRESS_LINE = `${ORG.venue.streetAddress}, ${ORG.venue.locality} ${ORG.venue.region} ${ORG.venue.postcode}`;

export const DEFAULT_OG_IMAGE = {
  url: `${SITE_URL}/og-image.jpg`,
  type: "image/jpeg",
  width: 1200,
  height: 630,
  alt: "Students and families at a Western Sydney Tamil Study Centre gathering",
};
